import React, { useState, useEffect } from "react";
import BackgroundImage from "/Images/Background.svg"; // Pastikan path benar
import "../Components/HeroTransition.css"; // Import the CSS file
import { useNavigate, useLocation } from "react-router-dom";

const styles = {
  container: {
    backgroundImage: `url(${BackgroundImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    padding: "0 6rem",
    paddingTop: "15rem",
    paddingBottom: "20rem",
    color: "#FFFFFF",
    textAlign: "center", // Pusatkan konten
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh", // Tinggi minimum untuk memenuhi viewport
  },
  heading: {
    fontSize: "48px",
    fontWeight: 600, // Bold
    lineHeight: "1.2",
    marginBottom: "2.5rem",
    maxWidth: "800px",
    marginTop: "2rem",
  },
  highlight: {
    color: "#F4E37B", // Warna kuning seperti pada gambar
  },
  subheading: {
    fontSize: "20px",
    color: "#E7E4E2",
    marginBottom: "3rem",
    maxWidth: "600px", // Batasi lebar teks agar proporsional
    lineHeight: "1.5",
  },
  button: {
    backgroundColor: "#F4E37B",
    color: "#214D73",
    padding: "15px 30px",
    borderRadius: "8px",
    border: "none",
    fontSize: "16px",
    cursor: "pointer",
   },
};

const HeroSection = () => {
  const navigate = useNavigate();
  const location = useLocation(); // Mendapatkan lokasi saat ini

  // Tambahkan fungsi handler untuk navigasi ke /bookmeeting
  const handleBookMeeting = () => {
    navigate("/bookmeeting"); // Arahkan ke halaman /bookmeeting
    window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll ke atas
  };

  return (
    <section style={styles.container}>
      {/* Heading */}
      <h1 style={styles.heading}>
        Unleash Your Potential <br />
        in the <span style={styles.highlight}>Digital Asset World</span>
      </h1>

      {/* Subheading */}
      <p style={styles.subheading}>
        Financial and other institutions can trust and integrate <br />
        our solutions seamlessly into their operations.
      </p>

      {/* Button */}
      <button
        onClick={handleBookMeeting} // Panggil handler navigasi
        style={styles.button}
      >
        Book a meeting
      </button>
    </section>
  );
};

export default HeroSection;
